import { Menu, MenuItem } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../../../../../reduxService/hooks';
import { cleanResults } from '../../../../MACRA_1/store/project/resultsSlice';
import { getActionByProjectType } from '../../../../actionMap';
import { endpoint } from '../../../../pages';
import { setProjectInfo } from '../../../../store/projectInfo/projectInfoSlice';
import { IOpenButtonProps } from './IOpenButton';
import ModalProjects from './ModalProjects/ModalProjects';

const OpenButton = (props: IOpenButtonProps) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const inputFile = React.useRef<HTMLInputElement | null>(null);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [openModal, setOpenModal] = React.useState<boolean>(false);

    const open = Boolean(anchorEl);

    const navigate = useNavigate();

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(e.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleOpenLocalFile = () => {
        inputFile.current?.click();
        setAnchorEl(null);
    };

    const handleChangeOpenLocalFile = (e: React.ChangeEvent<HTMLInputElement> | undefined) => {
        e!.preventDefault();
        const reader = new FileReader();
        reader.onload = async e => {
            const text = e.target!.result as string;
            let project: any = JSON.parse(text);
            dispatch(cleanResults());
            const { setProject } = getActionByProjectType(project.projectInfo.type);
            dispatch(setProjectInfo(project.projectInfo!));
            dispatch(
                setProject({
                    geometry: project.geometry,
                    hydraulicData: project.hydraulicData,
                    weirGeometry: project.weirGeometry,
                    wingsGeometry: project.wingsGeometry,
                    soilData: project.soilData,
                    stillingBasin: project.stillingBasin,
                }),
            );
            navigate(endpoint.designCondition);
        };
        reader.readAsText(e!.target.files![0]);
    };

    const openCloudProject = () => {
        setOpenModal(true);
    };

    const closeCloudProject = () => {
        setOpenModal(false);
        setAnchorEl(null);
    };

    return (
        <>
            <button type='button' className={props.className} onClick={handleClick}>
                <i className='fa-regular fa-folder-open' />
                {t('header_open_button')}
                <i className='fa-solid fa-angle-down' />
            </button>
            <Menu
                id='basic-menu-open'
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}>
                <MenuItem className={props.className} onClick={openCloudProject}>
                    {t('header_open_button_cloud')}
                </MenuItem>
                <MenuItem className={props.className} onClick={handleOpenLocalFile}>
                    {t('header_open_button_computer')}
                </MenuItem>
            </Menu>
            {openModal && <ModalProjects open={openModal} onClose={closeCloudProject} />}
            <input className='d-none' accept='.mcr' type='file' ref={inputFile} onChange={handleChangeOpenLocalFile} />
        </>
    );
};

export default OpenButton;
